import axios from "axios";
import {makeAuthFormData, makeFormData} from "../general-form-maker";
import {getRecaptchaToken} from '../../core/recapcha.js';
import {SIGNIN, SIGNUP} from '../../core/recapchaActions.js';
import {renderErrorByResponse} from '../modals/render-response';

export const authHandlers = () => {
    if ($('#signupquestionform-name').length > 0 && $('#signupquestionform-name').val().length > 0) {
        $('.field-signupquestionform-name').addClass('active');
    }

    $('#sign-in-submit').click(function () {
        getRecaptchaToken(SIGNIN).then(token => {
            sendData($(this).parents('form'), token);
        });
    });

    $('#registration-submit').click(function () {
        getRecaptchaToken(SIGNUP).then(token => {
            sendData($(this).parents('form'), token);
        });
    });

    $('#restore-submit').click(function () {
        const parent = $(this).parents('form');

        axios.post(parent.data('action'), makeFormData(parent))
            .then((response) => {
                if (response.data.redirect !== undefined) {
                    window.location.href = response.data.redirect;
                }
            }).catch((error) => {
            renderErrorByResponse(error.response, parent);
        });

        return false;
    });

    $('#restore-email').keypress(function (e) {
        const code = (e.keyCode ? e.keyCode : e.which);

        if (code === 13) {
            return false;
        }
    });

    $('#signupquestionform-name').keypress(function (e) {
        const code = (e.keyCode ? e.keyCode : e.which);

        if (code === 13) {
            $(this).parents('.registration__right-side').find('#reg-question-submit').click();

            return false;
        }
    });

    $('#restore-password-submit').click(function (e) {
        event.preventDefault();

        const parent = $(this).parents('#restore-password');
        let data = makeFormData(parent);

        data['hash'] = $(this).attr('data-hash');

        axios.post('/rest/auth/auth/new-password', data)
            .then((response) => {
                window.location.href = '/';
            })
            .catch((error) => {
                renderErrorByResponse(error.response, parent);
            });
    });

    $('.verify-email__button a').click(function (event) {
        event.stopPropagation();
        event.preventDefault();

        if ($(this).attr('href') !== '#') {
            axios.get($(this).attr('href'));
        }

        $(this).attr('href', '#');

        return false;
    });

    $('.apple-warning').click(function (event) {
        event.stopPropagation();
        event.preventDefault();

        $('#apple-warning-modal').modal('show');
    });

    $('.btn-sign-in-apple').click(function (event) {
        event.stopPropagation();
        event.preventDefault();

        window.location.href = '/auth/redirect-to-apple';
    });
};

const sendData = (parent, token) => {
    axios.post(parent.data('action'), makeAuthFormData(parent, token))
        .then((response) => {
            if (response.data.redirect !== undefined) {
                window.location.href = response.data.redirect;
            }
        })
        .catch((error) => {
            if (error.response && error.response.data && error.response.data.code === 410) {
                $('#profile-deleted-modal').modal('show');
            }

            renderErrorByResponse(error.response, parent);
        });
};
